import { Search } from "@mui/icons-material";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import MDBox from "components/MDBox";

interface Props {
  onChange: (value: string) => void;
}

export default function SearchMessengers({ onChange }: Props) {
  return (
    <MDBox sx={{ width: "100%" }}>
      <FormControl fullWidth variant="outlined" size="small">
        <InputLabel htmlFor="messenger-search">Buscar</InputLabel>
        <OutlinedInput
          id="messenger-search"
          type="text"
          placeholder="Nome, e-mail, empresa, equipe..."
          onChange={(e) => onChange(e.target.value)}
          endAdornment={
            <InputAdornment position="end">
              <Search fontSize="small" color="action" />
            </InputAdornment>
          }
          label="Buscar"
          sx={{
            borderRadius: 2,
            bgcolor: "background.paper",
          }}
        />
      </FormControl>
    </MDBox>
  );
}
